/* Hero — staggered content rise-in over the full-bleed video.
   Content is visible by default (LCP-safe); GSAP only enhances. */
(function () {
  'use strict';
  var hero = document.querySelector('[data-hero]');
  if (!hero) return;
  var Koi = window.Koi || {};

  // Slow the background video to the configured rate (re-applied on loop/metadata)
  var video = hero.querySelector('video');
  if (video) {
    var rate = parseFloat(hero.getAttribute('data-video-rate')) || 1;
    var apply = function () { try { video.playbackRate = rate; } catch (e) {} };
    apply();
    video.addEventListener('loadedmetadata', apply);
    video.addEventListener('play', apply);

    // Keep the muted background video looping through interactions, tab switches and
    // back/forward (bfcache) restores — browsers pause autoplay video on those and
    // don't resume on their own.
    video.loop = true;
    var ensurePlay = function () {
      if (document.hidden || !video.paused) return;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };
    video.addEventListener('pause', function () { if (!document.hidden) ensurePlay(); });
    video.addEventListener('ended', function () { try { video.currentTime = 0; } catch (e) {} ensurePlay(); });
    document.addEventListener('visibilitychange', ensurePlay);
    window.addEventListener('pageshow', ensurePlay);
  }

  function run() {
    var gsap = window.gsap;
    if (Koi.reduceMotion || !gsap) return;
    var rise = hero.querySelectorAll('[data-hero-rise]');
    if (rise.length) gsap.from(rise, { y: 26, opacity: 0, duration: 0.9, ease: 'power3.out', stagger: 0.1, delay: 0.15 });
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-hero]')) run();
  });
})();
